import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from '../authguard/auth.service';
import { ApiServicesService } from '../apiServices/api-services.service';
import { url } from 'inspector';
import { catchError, throwError, map, Observable } from 'rxjs';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Injectable({
  providedIn: 'root'
})
export class WhatsappServiceService {

  // private apiService: ApiServicesService = inject(ApiServicesService);
  // headers = new HttpHeaders()
  // .set('Content-Type', 'application/json')
  // .set('Authentication', `Bearer ${environment.KARIX_ACCOUNT_KEY}`);

  // constructor(private httpService: HttpClient, private loader: NgxUiLoaderService) { }

  // sendMessage() : Observable<any> {
  //   const payload = {
  //     "message": {
  //       "channel": "WABA",
  //       "content": {
  //         "preview_url": false,
  //         "type": "TEMPLATE",
  //         "template": {
  //           "templateId": "test",
  //           "parameterValues": {}
  //         }
  //       },
  //       "recipient": {
  //         "to": "917024979014",
  //         "recipient_type": "individual",
  //         "reference": {
  //           "cust_ref": "Some Customer Ref",
  //           "messageTag1": "Message Tag Val1",
  //           "conversationId": "Some Optional Conversation ID"
  //         }
  //       },
  //       "sender": {
  //         "from": "919607925900"
  //       },
  //       "preferences": {
  //         "webHookDNId": "1001"
  //       }
  //     },
  //     "metaData": {
  //       "version": "v1.0.9"
  //     }
  //   };

  //   // return this.httpService.post<any>(environment.KARIX_URL, payload, { headers: this.headers }).pipe(
  //   //   catchError((err) => {
  //   //     this.loader.stop();
  //   //     return throwError(err.error);

  //   //   }),
  //   //   map((resp) => {
  //   //     this.loader.stop();
  //   //     return resp
  //   //   }),
  //   // )
  // }

  createWhatsappUrl(requirementId: string, phoneNumber: string) {
    const productUrl = `https://raftaarr.com/product-detail?productId=${requirementId}`;

    const message =
      `Welcome to EFL Raftaar, we hope you are doing great today. \n\n` + // 👈 added space before \n\n
      `Please wait while we connect you to your Live Agent.\n\n` +
      `Check out this product: \n\n` +
      productUrl;

    const encodedMessage = encodeURIComponent(message);
    console.log(`https://wa.me/${phoneNumber}?text=${encodedMessage}`)
    return `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
  }
}
